import AnimatedCounter from "@/components/AnimatedCounter";
import Reveal from "@/components/landing/Reveal";

const DEFAULT_ITEMS = [
  { n: "{{numero_sucursales}}", l: "Sucursales", sub: "" },
  { n: "2", l: "CEDIS", sub: "" },
  { n: "+20", l: "Años", sub: "de experiencia en perfumería" },
  { n: "{{numero_estados}}", l: "Estados", sub: "con presencia" },
  { n: "$5 MDP", l: "Objetivo", sub: "Proyecto Diamante" },
];

export function resolveIndicator(n, ctx) {
  return String(n || "")
    .replace(/\{\{\s*numero_sucursales\s*\}\}/g, ctx.sucursales)
    .replace(/\{\{\s*numero_estados\s*\}\}/g, ctx.estados);
}

export default function IndicatorsSection({ block, locations }) {
  const items = block?.items?.length ? block.items : DEFAULT_ITEMS;
  const locs = (locations?.items || []).filter((l) => Number.isFinite(Number(l.lat)));
  const ctx = {
    sucursales: String(locs.length || 0),
    estados: String(new Set(locs.map((l) => (l.state || (l.city || "").split("·").pop()).trim()).filter(Boolean)).size),
  };
  const micro = block?.microcopy || "Infraestructura construida para continuar creciendo.";

  return (
    <section id="indicadores" className="bg-[#FAFAFA] py-16 md:py-24 relative" data-testid="indicators-section">
      <div className="max-w-[1300px] mx-auto px-5 sm:px-6 lg:px-10">
        {block?.eyebrow && (
          <Reveal><span className="eyebrow">{block.eyebrow}</span></Reveal>
        )}
        <div className={`grid grid-cols-2 md:grid-cols-3 lg:grid-cols-${Math.min(items.length, 6)} gap-x-6 gap-y-10 md:gap-y-12 ${block?.eyebrow ? "mt-8" : ""}`}>
          {items.map((it, i) => (
            <Reveal key={i} delay={i * 90} className={items.length % 2 === 1 && i === items.length - 1 ? "col-span-2 md:col-span-1" : ""}>
              <div className="border-l border-black/10 pl-4 md:pl-5" data-testid={`indicator-${i}`}>
                <div className="font-display text-[44px] sm:text-[52px] md:text-[60px] lg:text-[68px] leading-none tracking-tight text-[#0A0A0A] num-mono">
                  <AnimatedCounter value={resolveIndicator(it.n, ctx)} duration={900} />
                </div>
                <div className="mt-3 text-[11px] md:text-xs uppercase tracking-[0.18em] text-[#0A0A0A] font-semibold font-mono">{it.l}</div>
                {it.sub && <div className="mt-1 text-xs md:text-sm text-[#52525B] leading-snug">{it.sub}</div>}
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={200}>
          <div className="mt-12 md:mt-16 flex items-center gap-3 text-xs md:text-sm text-[#52525B]">
            <span className="h-px w-8 bg-[#FFBF57]" />
            {micro}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
